<template>
  <div>
    <el-select
      v-bind="$attrs"
      v-model="currentVal"
      filterable
      remote
      reserve-keyword
      placeholder="请输入关键词"
      :remote-method="remoteMethod"
      :loading="loading"
      @change="handleSelectChange"
      @blur="handleSelectBlur">
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
// import ElSelect from './select/index'
export default {
  name: 'remoteSelect',
  model: {
    prop: 'val',
    event: 'input'
  },
  props: ['val', 'requestMethod', 'label', 'value'],
  components: {
    // [ElSelect.name]: ElSelect
  },
  data() {
    return {
      options: [],
      currentVal: null,
      loading: false
    }
  },
  watch: {
    val(val) {
      this.currentVal = val;
    }
  },
  mounted() {
    if(this.multiple) {
      this.currentVal = []
    }else{
      this.currentVal = ''
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        // 业务代码
        this.getOptions(query)
      } else {
        this.options = [];
      }
    },
    getOptions(str) {
      return this.requestMethod(str)
      .then(res=>{
        if(this.value && this.label) {
          this.options = res.data.map(v=>{
            return {
              value: v[this.value],
              label: v[this.label],
              ...v
            }
          });
        }
        if(!this.value && !this.label) {
          this.options = res.data.map(v=>{
            return {
              value: v,
              label: v
            }
          });
        }
      })
      .finally(_=>{
        this.loading = false;
      })
    },
    handleSelectChange(data) {
      this.$emit('input', data);
      this.$emit('isSelect', true);
      this.$emit('activedNode', this.options.find(v=>v.value === data))
    },
    handleSelectBlur(el) {
      if(!this.options.length) {
        const data = el.target.value;
        setTimeout(_=>{
          this.currentVal = data;
          this.$emit('input', data);
          this.$emit('isSelect', false);
        }, 300)
      }
    }
  }
}
</script>

<style>

</style>